export default __webpack_public_path__ + "static/media/5.5e956847.png";